import { Component, OnInit } from '@angular/core';
import {AutoService} from '../services/auto.service';
import {TinyService} from '../services/tiny.service';
import {Auto} from '../admin/auto/model/auto';
import {Observable} from 'rxjs/Rx';
import {HostListener} from '@angular/core';
import {ActivatedRoute, Router } from '@angular/router';
import {UserService} from '../services/user.service';
import {CookieService} from 'ng2-cookies';

@HostListener('window:keydown', ['$event'])
@Component({
  host: {
    '(document:keydown)': 'keyDown($event)',
  },
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
 })
 
export class HomeComponent implements OnInit {
  	autos: Auto[];
	public selectedAuto;
	searchText = "";
	oldSearchText = "";
	selectedIndex = 0;
	show = true;
	showAuto = false;
	currentPage = 0;
        pageSize = 8;
        pageDirection = -1;
        totalCount = 0;
        pageCount = 0;
	working = true;
	counter = 0;
	tin = ""

  @HostListener('click')
  clickInside() {
    this.showAuto = true;
  }

  @HostListener('document:click')
  clickout() {
      this.showAuto = false;
  }

public LOGO = require("../../assets/donut.png");
theUser: string;
gwt: string;

constructor(private autoService: AutoService, private tinyService: TinyService, private activatedRoute: ActivatedRoute, private router: Router, private userSVC: UserService, private _cookieService:CookieService){}

    ngOnInit(){
      this.gwt = this.getCookie("gwt");
      if(this.gwt) {
        this.userSVC.sessionVerifyGwt(this.gwt);
        setTimeout(()=>{this.theUser = this.userSVC.authUser.email;}, 1000)
      } else {
        this.router.navigate(['']);
      }

      this.activatedRoute.queryParams.subscribe(params => {
                        this.searchText = params['s'] || "";
                        if(this.searchText != "") {
                                this.setFirstPage();
				} else {
					this.tiny();
				}
                });
    }

   setCookie(key: string, value: string){
        return this._cookieService.set(key, value);
      }
     getCookie(key: string){
        return this._cookieService.get(key);
      }
 signup(){
    this.router.navigate(['signup']);
  }

  auto() {
	//Use a queue for managing in-flight requests

        var res = this.searchText.trim().split(" ");
        var txt = res[res.length - 1];
        txt = txt.trim()
	var head  = this.searchText.substring(0,this.searchText.indexOf(txt)).trim();

	this.counter++;
	var thisCounter = this.counter;
	var timeoutId = setTimeout(()=> {
  this.showAuto = false;
	if (txt.length > 2) {
			this.autos = new Array();
			//TODO: [0] current auto textbox value
			//	let t = new Auto();
			//	 this.searchText;
			//	 t.Rank = 0;
			//	 this.autos = new Array()
			//	 this.autos[0] = t;

				this.autoService.auto(txt)
					   .subscribe(
					       data => {
					       //				this.autos = this.autos.concat(data); //Bind to view
					       if (this.counter == thisCounter) {
								this.autos = data; //Bind to view

				        if (this.autos.length > 0) {
                  this.showAuto = true;
                  } else {
                    this.showAuto = false;
                  }

								var i;
								for (i = 0; i < this.autos.length; i++) {
								  this.autos[i].Name = head  + " " + this.autos[i].Name;
								}
						}
						},
						err => {
							console.log(err);
						});
			} else {
				this.autos = new Array();
				this.showAuto = false;
			}
		}, 1000/60);
		//	clearTimeout(timeoutId);
	}

	tiny() {
			this.tin = "";
			this.tinyService.tiny()
					   .subscribe(
					       data => {
							this.tin = data.text().slice(1, -1);
							//alert(this.tin);
						});
	}

	 public selectAuto( auto: any, i: number) {
                this.selectedIndex = i;
                this.selectedAuto =  auto;
		this.searchText = this.selectedAuto.Name;
        	this.setFirstPage()
		this.showAuto = false;
        }

	 keyDown(event: any) {
                switch (event.keyCode) {
                        case 38:
                                this.onUp();
                                event.preventDefault();
                                break;
                        case 40:
                                this.onDown()
                                event.preventDefault();
                                break;
                        case 13:
                                this.setFirstPage()
                                event.preventDefault();
                                break;
                }
                return;
	}

	public onDown() {
                if(this.selectedIndex < this.autos.length - 1)
                {
                        this.selectedAuto = this.autos[++this.selectedIndex];
			this.searchText = this.selectedAuto.Name;
                }
        }

        public onUp() {
                if(this.selectedIndex > 0)
                {
                        this.selectedAuto = this.autos[--this.selectedIndex];
			this.searchText = this.selectedAuto.Name;
                }
        }

        setFirstPage() {
		if(this.searchText.length > 0) {
			this.router.navigateByUrl('/search?q='+this.searchText+'&l='+this.tin);
		 }
        }

  searchGleanbee() {
           if(this.searchText.length > 0) {
             window.location.href = '/admin/redirect?u=topic&q='+this.searchText
            }
         }

  gotoGleanbee() {
             window.location.href = '/admin/redirect?u=topic&q='+this.searchText
         }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts